module.exports = __webpack_public_path__ + "static/img/icon-design-dropdown.51c1a5ed.png";